import axios from '@/libs/api.request';

export const loginRequest = data => {
    return axios.request({
        url: 'api/user/userLogin',
        data: data,
        method: 'post'
    });
};

export const getUserInfo = data => {
    return axios.request({
        url: 'api/user/getUserInfo',
        data: data,
        method: 'post'
    });
};

export const getUserInfoByToken = data => {
    return axios.request({
        url: 'api/user/getUserInfoByToken',
        data: data,
        method: 'post'
    });
};
